import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Client } from '@df/core/service/client';
import { BreadcrumbsComponentDef } from '@df/ui/common/breadcrumbs.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

/**
 * Breadcrumbs component
 *
 * ## usage
 *
 * <breadcrumbs></breadcrumbs>
 */
@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.html',
    standalone: true,
    imports: [RouterModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent extends BreadcrumbsComponentDef {
    client = inject(Client);
}
